import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconButton, Icon } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const CloseRequestWarning = ({ button }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const navigate = useNavigate()
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  return (
    <>
      {button ? (
        <AdxButton variant={'outlined'} onClick={handleOpen} sx={{ width: '100px' }}>
          Close
        </AdxButton>
      ) : (
        <IconButton onClick={handleOpen}>
          <Icon sx={{ color: 'dark-text.main', fontSize: 20 }}>close</Icon>
        </IconButton>
      )}

      <AdxInfoModal
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="warning"
        iconColor="error.main"
        title="Exit Credit Leave Policy ?"
        subtitle="Any unsaved changes will be discarded"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={() => navigate(-1)}
        secondBtnLabel={'Close'}
        secondBtnHandle={handleClose}
      />
    </>
  )
}

export default CloseRequestWarning
